import { withInstall } from '@element-plus/utils/with-install'

import Tag from './src/tag.vue'

export const ElTag = withInstall(Tag)
export default ElTag

export * from './src/tag'
